import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { GoChevronRight } from 'react-icons/go';

function SuccessStories() {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const captionStyleheader = {
    textAlign: 'center',
    padding: '2px',
    marginTop: '2rem',
    marginBottom: '5rem',
  };

  const captionTextStyle = {
    fontSize: '2rem',
    // fontWeight: 'bold',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#2855A1',
    marginTop: '2rem',
    marginBottom: '2rem',
  };

  const captionTextStyle2 = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: 'black',
    // fontWeight: 'bold',
  };

  const captionTextStyle3 = {
    fontSize: '1.2rem',
    textOverflow: 'ellipsis',
    color: 'black',
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: '3',
    marginBottom: '2rem', // Add margin for responsiveness
  };

  const imageStyle = {
    objectFit: 'cover',
    filter: 'opacity(2) brightness(1)',
    width: '100%', // Set the width to 100% to match the card width
  };

  const buttonContainerStyle = {
    textAlign: 'left', // Align the button to the left
    marginBottom: '2rem', // Add margin for responsiveness
  };

  const buttonStyle = {
    fontSize: '14px',
    fontWeight: 600,
    border: 'none',
    backgroundColor: isHovered ? '#F7F9FF' : '#FFE114',
    color: isHovered ? 'black' : 'black',
    transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s',
    transform: isHovered ? 'translateX(10px)' : 'translateX(0)',
  };

  return (
    <Container
      fluid
      style={{
        marginBottom: '10px',
        height: 'auto',
        marginTop: '10px',
      }}
    >
      <Container style={{ padding: '2px', marginTop: '50px', ...captionStyleheader }}>
        <Row className="justify-content-center">
          {/* Show two columns on md, lg, and xl screens */}
          <Col xs={12} sm={12} md={12} lg={5}>
            <Container fluid>
              <h1 style={{ ...captionTextStyle, textAlign: 'left' }}>
                Success  <span style={captionTextStyle2}> Stories </span> 
              </h1>
              <p
                style={{
                  ...captionTextStyle3,
                  width: '100%',
                  textAlign: 'justify',
                  marginBottom: '1rem', // Add margin at the bottom for larger screens
                  marginRight: '0', // Reset right margin
                }}
              >
                At Ascent, we stand out through our fundamental belief that your success defines ours. Our affordable and impactful services are delivered with a genuine commitment to fostering your growth and well- being. Our success stories are self-evident, each reflecting a history of mutual achievements and long-lasting relationships.
              </p>
            </Container>
            <div style={buttonContainerStyle}>
              <Button
                className="mt-3 mt-md-4 mt-lg-5"
                variant="warning"
                size="lg"
                active
                style={buttonStyle}
                href=" /SuccessStories" // Add the desired URL here
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                &nbsp;&nbsp; Read Client Testimonials &nbsp;&nbsp;
                <span style={{ fontSize: '20px' }}>
                  <GoChevronRight />
                </span>
                &nbsp;&nbsp;
              </Button>
            </div>
          </Col>
          
          {/* Show single column on xs and sm screens */}
          <Col xs={12} sm={12} md={12} lg={5}>
            <Image
              src={process.env.PUBLIC_URL + '/assets/images/SuccessStories.png'}
              alt=""
              style={{ ...imageStyle, width: '100%' }}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default SuccessStories;
